export type PeerReviewDrillMetric =
  | 'total'
  | 'pending'
  | 'concur'
  | 'minor_discrepancy'
  | 'clinically_significant_discrepancy'
  | 'discrepancy'
  | 'corrective_actions';

export interface PeerReviewAnalyticsDrillParams {
  metric?: PeerReviewDrillMetric;
  trendBucket?: string;
  drillModality?: string;
  drillReviewerId?: string | number;
}

export interface PeerReviewAnalyticsActiveFilters {
  startDate: string;
  endDate: string;
  modality?: string;
  radiologistId?: string;
  remark?: string;
  priority?: string;
  bodyPart?: string;
  trendPeriod?: 'day' | 'week' | 'month';
}

export function buildPeerReviewCasesSearchParams(
  filters: PeerReviewAnalyticsActiveFilters,
  drill: PeerReviewAnalyticsDrillParams = {}
): URLSearchParams {
  const params = new URLSearchParams();
  params.set('start_date', filters.startDate);
  params.set('end_date', filters.endDate);
  if (filters.modality) {
    params.set('modality', filters.modality);
  }
  if (filters.radiologistId) {
    params.set('radiologist_id', filters.radiologistId);
  }
  if (filters.remark) {
    params.set('remark', filters.remark);
  }
  if (filters.priority) {
    params.set('priority', filters.priority);
  }
  if (filters.bodyPart) {
    params.set('body_part', filters.bodyPart);
  }
  if (filters.trendPeriod) {
    params.set('trend_period', filters.trendPeriod);
  }
  if (drill.metric && drill.metric !== 'total') {
    params.set('metric', drill.metric);
  }
  if (drill.trendBucket) {
    params.set('trend_bucket', drill.trendBucket);
  }
  if (drill.drillModality) {
    params.set('drill_modality', drill.drillModality);
  }
  if (drill.drillReviewerId != null && String(drill.drillReviewerId) !== '') {
    params.set('drill_reviewer_id', String(drill.drillReviewerId));
  }
  return params;
}

export function buildPeerReviewCasesPath(
  filters: PeerReviewAnalyticsActiveFilters,
  drill: PeerReviewAnalyticsDrillParams = {}
): string {
  return `/analytics/peer-review/cases?${buildPeerReviewCasesSearchParams(filters, drill).toString()}`;
}

export function drillMetricLabel(metric?: string): string {
  switch (metric) {
    case 'pending':
      return 'Pending peer reviews';
    case 'concur':
      return 'Concur';
    case 'minor_discrepancy':
      return 'Minor discrepancy';
    case 'clinically_significant_discrepancy':
      return 'Clinically significant discrepancy';
    case 'discrepancy':
    case 'corrective_actions':
      return 'Discrepancy';
    case 'total':
    default:
      return 'All peer reviews';
  }
}
